import { StructureType } from '../types/types';
import { isJson } from './dataTypes';
import dayjs from 'dayjs';

export const getModelInfo = (filter: string): { id: string; name: string } => {
 try {
  if (!isJson(filter) || !filter) {
   console.log(`filter is not a valid JSON: ${filter}`);
   return { id: '', name: '' };
   //    throw new Error(`filter is not a valid JSON: ${filter}`);
  }

  const id = isJson(filter || '')
   ? JSON.parse(filter || '').fields.split(',')[0]
   : 'Id';
  const name = isJson(filter || '')
   ? JSON.parse(filter || '').fields.split(',')[1]
   : 'Name';
  return { id, name };
 } catch (error) {
  console.log(error);
  throw new Error('getModelInfo error');
 }
};

export function displayValueByType(value: any, structure: StructureType) {
 let val = value;

 if (val === null || val === undefined) {
  val = '-';
 } else if (structure?.Type === 'model') {
  if (typeof val === 'object' && !Array.isArray(val)) {
   const { name: nameVar } = getModelInfo(
    structure.ForeignKeyDefaultFilter || '',
   );
   const displayed = nameVar
    ? (val as Record<string, unknown>)[nameVar]
    : undefined;
   val =
    displayed !== null && displayed !== undefined
     ? String(displayed)
     : JSON.stringify(val);
  } else {
   val = String(val);
  }
 } else if (structure?.Type === 'array') {
  const { name: nameVar } = getModelInfo(
   structure?.ForeignKeyDefaultFilter || '',
  );
  val = Array.isArray(val)
   ? val.map((item: any) => item[nameVar]).join(', ')
   : JSON.stringify(val);
 } else if (typeof val === 'object') {
  val = JSON.stringify(val);
 } else if (structure?.Type === 'boolean') {
  val = val ? 'Taip' : 'Ne';
 } else if (structure?.Type === 'enum') {
  val = structure?.EnumValues[value];
 } else if (['int32', 'int16', 'double'].includes(structure?.Type)) {
  val = value;
 } else if (structure?.Type === 'datetime') {
  val = value ? dayjs(value).format('DD.MM.YYYY HH:mm') : '-';
 } else if (structure?.Type === 'string') {
  val = value;
 } else {
  val = value;
 }
 if (val !== null && typeof val === 'object') {
  return JSON.stringify(val);
 }
 return val as string | number;
}

